/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SimpleTimeWorkedCalculationRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {TimecardOvertimeSegmentsResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const timecardOvertimeSegments = (request: SimpleTimeWorkedCalculationRequest, options?: CashRequestOptions) => post<SimpleTimeWorkedCalculationRequest, TimecardOvertimeSegmentsResponse>("/proxy/services/squareup.timecards.TimeCalculationReportService/TimecardOvertimeSegments", request, {...options, rejectOnError: true })